/**
 * Reseller Discount Clearer
 * Clears reseller discount/session traces when customer logs out.
 */
(function () {
  'use strict';

  var LOG_PREFIX = '[ResellerDiscountClearer]';
  var LOGGED_OUT_CLEANUP_FLAG = 'reseller_discount_logged_out_cleanup_done';

  var STORAGE_KEYS = [
    'applied_reseller_discount_code',
    'reseller_discount_redirect_in_progress',
    'discount_code',
    'reseller_discount',
    'cart_discount',
    'applied_discount',
    'wcp_discount_code',
    'wcp_data'
  ];

  var CART_ATTRIBUTE_KEYS = ['discount_code', 'reseller_discount', 'cart_discount', 'applied_discount'];

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.warn.apply(console, args);
  }

  function clearCookieByName(name) {
    if (!name) return;

    var hostname = window.location.hostname || '';
    var domainParts = hostname.split('.').filter(Boolean);
    var rootDomain = domainParts.length > 2 ? '.' + domainParts.slice(-2).join('.') : '';

    var variants = [
      name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;',
      name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + hostname + ';'
    ];

    if (rootDomain) {
      variants.push(name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + rootDomain + ';');
    }

    variants.forEach(function (cookie) {
      document.cookie = cookie;
    });
  }

  function clearStorageArea(storage, areaName) {
    if (!storage) return;

    try {
      STORAGE_KEYS.forEach(function (key) {
        try {
          storage.removeItem(key);
        } catch (error) {
          warn('Could not remove key from ' + areaName + ':', key, error);
        }
      });

      var keysToRemove = [];
      for (var i = 0; i < storage.length; i += 1) {
        var key = storage.key(i);
        if (!key) continue;

        if (/(discount|reseller|wcp)/i.test(key)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(function (key) {
        try {
          storage.removeItem(key);
        } catch (error) {
          warn('Could not remove pattern key from ' + areaName + ':', key, error);
        }
      });

      log(areaName + ' cleared keys:', keysToRemove.length + STORAGE_KEYS.length);
    } catch (error) {
      warn('Failed to clear ' + areaName + ':', error);
    }
  }

  function clearClientStorage() {
    clearStorageArea(window.localStorage, 'localStorage');
    clearStorageArea(window.sessionStorage, 'sessionStorage');
  }

  function clearDiscountCookies() {
    var staticCookieNames = ['discount_code', 'cart_discount', 'reseller_discount', '_shopify_discount'];

    staticCookieNames.forEach(clearCookieByName);

    try {
      var dynamicCookieNames = document.cookie
        .split(';')
        .map(function (entry) {
          return entry.split('=')[0] ? entry.split('=')[0].trim() : '';
        })
        .filter(Boolean)
        .filter(function (name) {
          return /(discount|reseller|wcp)/i.test(name) || /^wcp_discount_/i.test(name);
        });

      dynamicCookieNames.forEach(clearCookieByName);
      log('Cleared discount-related cookies:', dynamicCookieNames.length + staticCookieNames.length);
    } catch (error) {
      warn('Failed to clear dynamic cookies:', error);
    }
  }

  function clearAllDiscountStorage() {
    clearClientStorage();
    clearDiscountCookies();
  }

  function clearCartDiscountAttributes() {
    var attributes = {};
    CART_ATTRIBUTE_KEYS.forEach(function (key) {
      attributes[key] = '';
    });

    log('Clearing cart discount attributes...');

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart update returned non-OK status: ' + response.status);
        }
        return response.json();
      })
      .then(function () {
        log('Cart discount attributes cleared.');
      })
      .catch(function (error) {
        warn('Cart discount attribute clear warning:', error);
      });
  }

  function clearAppliedDiscountCode() {
    log('Clearing applied cart discount code...');

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' }),
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Discount reset returned non-OK status: ' + response.status);
        }
        return response.json();
      })
      .then(function () {
        log('Applied cart discount code cleared.');
      })
      .catch(function (error) {
        warn('Applied cart discount code clear warning:', error);
      });
  }

  function clearAllDiscountsAndContinue(logoutUrl) {
    log('🧹 Clearing discounts...');

    clearAllDiscountStorage();

    clearCartDiscountAttributes()
      .then(function () {
        return clearAppliedDiscountCode();
      })
      .finally(function () {
        log('✓ Discount cleared, redirecting to logout...');

        // Direct redirect (no delay, no reload)
        window.location.href = logoutUrl || '/account/logout';
      });
  }

  function isLogoutPath(value) {
    if (!value) return false;

    try {
      var parsed = new URL(value, window.location.origin);
      return parsed.pathname.indexOf('/account/logout') === 0;
    } catch (error) {
      return String(value).indexOf('/account/logout') !== -1;
    }
  }

  function attachLogoutInterceptors() {
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link || !isLogoutPath(link.href)) return;

      event.preventDefault();
      log('Logout link click detected:', link.href);
      clearAllDiscountsAndContinue(link.href);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.action || !isLogoutPath(form.action)) return;

      event.preventDefault();
      log('Logout form submit detected:', form.action);
      clearAllDiscountsAndContinue(form.action);
    });
  }

  function runLoggedOutSafetyCleanup() {
    if (window.CLEENLAB_IS_LOGGED_IN !== false) return;

    try {
      if (sessionStorage.getItem(LOGGED_OUT_CLEANUP_FLAG) === 'true') {
        return;
      }
      sessionStorage.setItem(LOGGED_OUT_CLEANUP_FLAG, 'true');
    } catch (error) {
      // Ignore storage failures; still run cleanup
    }

    log('Visitor is logged out, running one-time discount trace cleanup.');
    clearClientStorage();
    clearDiscountCookies();
    clearCartDiscountAttributes();
    clearAppliedDiscountCode();
  }

  log('🔧 Reseller Discount Clearer loaded');

  attachLogoutInterceptors();
  runLoggedOutSafetyCleanup();
  log('✓ Logout interception active');
})();
